import { Checkbox, FormHelperText, TextField } from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import Autocomplete from '@material-ui/lab/Autocomplete'

import * as R from 'ramda'
import React, { FC, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useQuery } from 'react-query'

import { CategoryListInterface } from '../../interfaces/category'
import { categoryApi } from '../../services'

type Props = {
  fieldName: string
  fieldValue: { categoryId: string; name: string }
  rules?: any
  disable?: boolean
  required?: boolean
}

type CategoryOptions = Pick<CategoryListInterface, 'categoryId' | 'name'>

// currently only get a limit of 100 items, need other implementation if categoryItem excess this number
const useGetAllCategories = () => {
  return useQuery<CategoryListInterface[], Error>(
    'searchCategory',
    categoryApi.getAllCategories
  )
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const CategoryAutoCompleteSelector: FC<Record<string, unknown> & Props> = ({
  fieldName,
  fieldValue,
  rules = {},
  disable = false,
  required = false
}) => {
  const { control, setValue } = useFormContext()
  const [inputValue, setInputValue] = useState<string>(fieldValue.name)

  const {
    isLoading,
    data: options = []
  }: {
    isLoading: boolean
    data: CategoryOptions[] | undefined
  } = useGetAllCategories()

  return (
    <Controller
      control={control}
      name={fieldName}
      rules={{
        ...rules,
        required: {
          value: required,
          message: '* Your input is required'
        }
      }}
      as={
        <>
          <Autocomplete
            id="category-autoComplete-selector"
            fullWidth
            disableClearable
            disabled={disable}
            onChange={(_event, newValue) => {
              setValue(fieldName, R.propOr('', 'categoryId', newValue))
            }}
            inputValue={inputValue}
            onInputChange={(_event, newInputValue) => {
              // This implementation is due to odd behaviour where onInputChange is being executed on first mount
              // where it will change the input value to blank
              if (R.not(R.isEmpty(newInputValue))) {
                setInputValue(newInputValue)
              }
            }}
            getOptionSelected={(option, value) => {
              return option.name === value.name
            }}
            getOptionLabel={(option) => option.name}
            options={options}
            loading={isLoading}
            renderOption={(option, { selected }) => (
              <>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.name} - {option.categoryId}
              </>
            )}
            renderInput={(params) => <TextField {...params} />}
          />
          {required && <FormHelperText>Required</FormHelperText>}
        </>
      }
    />
  )
}

export default CategoryAutoCompleteSelector
